import { css, keyframes } from '@emotion/react'

import Colors from '../theme/Colors'

const BouncingAnimation = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
`

export default function LoadingBubbles(props: { size?: 8 | 12 | 14 | 18 | 20; color?: string }) {
  const { size = 18, color = Colors.Teal400 } = props

  const bouncingStyle = css`
    display: inline-block;
    border-radius: 100%;
    animation: ${BouncingAnimation} 1.4s infinite ease-in-out both;
    width: ${size}px;
    height: ${size}px;
    background: ${color};
  `

  return (
    <div
      data-testid="loader-element"
      css={css`
        position: relative;
        display: inline-flex;
        margin: auto;
        width: auto;
        vertical-align: middle;
        text-align: center;
      `}
    >
      <div css={bouncingStyle} />

      <div
        css={css`
          ${bouncingStyle};
          animation-delay: 0.16s;
        `}
      />

      <div
        css={css`
          ${bouncingStyle};
          animation-delay: 0.32s;
        `}
      />
    </div>
  )
}
